module.exports = __webpack_public_path__ + "img/robot.9a321139.svg";